<template lang="pug">
  .account-funds-element
    .card
      .card-content
        .content
          .field.is-horizontal
            label.label.name {{ gettext('Amount') }}
            .field-body
              input.input(
                type="number"
                v-model="amount"
                :disabled="disabled"
                @input="inputData"
                :min="amountMin"
                :max="amountMax"
                :class="{'is-danger':error}")
          .field.is-horizontal(v-if="data.charge && !manual")
            p {{interpolate(gettext('Will be charged %s EUR'), [data.charge])}}
          .field.is-horizontal(v-show="error")
            p.error {{error}}
</template>
<script>

import Vue from 'vue'
import { gettext, interpolate } from '@/services/TranslateHandler'
import Vuelidate from 'vuelidate'
import { minValue, maxValue, required } from 'vuelidate/lib/validators'
Vue.use(Vuelidate)

export default {
  name: 'AccountFundsElement',
  data () {
    return {
      amount: ''
    }
  },
  props: {
    data: {
      default: () => {
        return {}
      }
    },
    disabled: {
      default: false
    },
    manual: {
      default: false
    },
    error: {
      default: ''
    },
    amountMin: {
      default: 0
    },
    amountMax: {
      default: 100
    }
  },
  validations () {
    return {
      amount: {
        minValue: minValue(this.amountMin),
        maxValue: maxValue(this.amountMax),
        required
      }
    }
  },
  created () {
    this.$emit('created')
  },
  methods: {
    gettext: gettext,
    interpolate: interpolate,
    inputData () {
      this.$v.amount.$touch()
      this.$emit('updated', parseFloat(this.amount).toFixed(2))
    }
  },
  computed: {
    isValid: function () {
      return !this.$v.$invalid
    }
  },
  watch: {
    data: {
      deep: true,
      handler: function (val) {
        this.amount = parseFloat(val.amount)
      }
    },
    manual: function () {
      this.$emit('created')
    },
    isValid: function (val) {
      this.$emit('isValid', val)
    }
  }
}
</script>
<style lang="scss">
  .account-funds-element {
    .field {
      &.is-horizontal {
        align-items: center;
        .label{
          margin: 0 10px 0 0;
        }
        .field-body {
          input {
            border: 1px solid #dbdbdb;
            &.is-danger {
              border: 1px solid #c60733;
            }
          }
        }
        p.error {
          color: #c60733;
          font-size: small;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/billing/invoice/components/account-funds-element/index.vue